import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./Editmetal_purity_karat.css";
import {
  getAllMetalPurityCarat,
  updateMetalPurityCarat,
} from "../../../../services/metal_purity_karat/metal_purity_karat.service";
import { MetalPurityCaratType } from "../../../../services/metal_purity_karat/metal_purity_karat.types";
import { toast } from "react-toastify";

const EditMetalPurityCarat: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [form, setForm] = useState<MetalPurityCaratType | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (!id) return;
      try {
        const res = await getAllMetalPurityCarat();
        const record = res.data.find((item: MetalPurityCaratType) => item.id === Number(id));
        if (!record) {
          toast.error("Record not found");
          navigate("/metal-type-purity/list");
          return;
        }
        setForm(record);
      } catch (error) {
        toast.error("Failed to load record");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, navigate]);

  const toNumberOrNull = (value: string) => {
    if (value === "") return null;
    const num = Number(value);
    return Number.isNaN(num) ? null : num;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!id || !form) return;

    const isGold = form.Metal_type?.name?.toLowerCase().includes("gold") || form.metalTypeId === 1;
    const isDiamond = form.Metal_type?.name?.toLowerCase().includes("diamond") || form.metalTypeId === 2;
    const isSilver = form.Metal_type?.name?.toLowerCase().includes("silver") || form.metalTypeId === 3;

    const payload: Partial<MetalPurityCaratType> = {
      metalTypeId: form.metalTypeId,
      karat: isGold ? form.karat || null : null,
      purity: (isGold || isSilver) ? toNumberOrNull(String(form.purity ?? "")) : null,
      carat: isDiamond ? toNumberOrNull(String(form.carat ?? "")) : null,
      centValue: isDiamond ? toNumberOrNull(String(form.centValue ?? "")) : null,
    };

    try {
      await updateMetalPurityCarat(Number(id), payload);
      toast.success("Metal purity updated");
      navigate("/metal-type-purity/list");
    } catch (error) {
      console.error(error);
      toast.error("Update failed");
    }
  };

  if (loading || !form) return <div>Loading...</div>;

  const metalName = form.Metal_type?.name || "";
  const lowerName = metalName.toLowerCase();
  const isGold = lowerName.includes("gold") || form.metalTypeId === 1;
  const isDiamond = lowerName.includes("diamond") || form.metalTypeId === 2;
  const isSilver = lowerName.includes("silver") || form.metalTypeId === 3;

  return (
    <div className="edit-overlay">
      <div className="edit-container">
        <h2>Edit Metal Purity / Carat</h2>
        <p className="meta-label">Metal Type: <strong>{metalName || "-"}</strong></p>

        <form onSubmit={handleSubmit}>
          {isGold && (
            <>
              <label>Karat</label>
              <input
                type="text"
                value={form.karat || ""}
                onChange={(e) => setForm({ ...form, karat: e.target.value })}
                placeholder="Karat (e.g. 22K)"
              />

              <label>Purity (%)</label>
              <input
                type="number"
                value={form.purity ?? ""}
                onChange={(e) =>
                  setForm({ ...form, purity: e.target.value === "" ? null : Number(e.target.value) })
                }
                placeholder="Purity"
              />
            </>
          )}

          {isSilver && (
            <>
              <label>Purity (%)</label>
              <input
                type="number"
                value={form.purity ?? ""}
                onChange={(e) =>
                  setForm({ ...form, purity: e.target.value === "" ? null : Number(e.target.value) })
                }
                placeholder="Purity"
              />
            </>
          )}

          {isDiamond && (
            <>
              <label>Carat</label>
              <input
                type="number"
                value={form.carat ?? ""}
                onChange={(e) =>
                  setForm({ ...form, carat: e.target.value === "" ? null : Number(e.target.value) })
                }
                placeholder="Carat"
              />

              <label>Cent Value</label>
              <input
                type="number"
                value={form.centValue ?? ""}
                onChange={(e) =>
                  setForm({ ...form, centValue: e.target.value === "" ? null : Number(e.target.value) })
                }
                placeholder="Cent Value"
              />
            </>
          )}

          <div className="button-close">
            <button type="button" onClick={() => navigate("/metal-type-purity/list")}>
              Close
            </button>
            <button type="submit">Update</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditMetalPurityCarat;
